import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchCarMakesMutation } from '../../../services'
import { UspConfigurationCarMakeTypeViewResult } from '../../../models'
import InventoryMakesTable from './components/InventoryMakesTable'
import AddEditMakesModal from './components/AddEditMakesModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsInventoryMakes = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchCarMakes, { data, isLoading }] = useSearchCarMakesMutation()
  const [carMakeData, setCarMakeData] = useState<UspConfigurationCarMakeTypeViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchCarMakes({
      uspConfigurationCarMakeTypeView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCarMakeData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Makes'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='Makes' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <InventoryMakesTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={carMakeData}
                      setData={setCarMakeData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditMakesModal submit={submit} open={openAddEditModal} onClose={handleCloseModal} type={type} rowData={rowData as any} />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsInventoryMakes
